import React from 'react';

export const PersonPhoto = ({ name, photo, className = '' }) => {
  if (photo) {
    return <img src={photo} alt={name} className={`object-cover grayscale ${className}`} />;
  }
  const initials = name
    .split(' ')
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
  return (
    <div className={`flex items-center justify-center bg-[#161514] ${className}`} aria-label={name}>
      <span className="font-serif text-champagne" style={{ fontSize: 'clamp(1.5rem, 4vw, 3rem)' }}>{initials}</span>
    </div>
  );
};
